/* 
 * Focus point plugin
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
var $ = require('jquery');
require('../plugins/jquery.focuspoint');

// Modul construct
var somModul = {
	
	// Module name
	name: 'focuspoint',
	
	// Container
	container: null,
	
	// Init function
	init: function() {
		
		// Init vars
		var componentConfig = this.__getComponentConfig(somModul.name);
		somModul.container = $(componentConfig.selector);

		if(componentConfig.enabled && somModul.container.length != 0) {

			// Init focuspoint
			somModul.container.focusPoint(componentConfig.config);
			
			// Re adjust focuspoint on interchange activity
			somModul.container.find('img').on('replaced.zf.interchange', function() {
				$(this).parent().data('focusPoint').adjustFocus();
			});
		
			// Re adjust focuspoint on image slide
			$('.orbit').on('slidechange.zf.orbit', function(orbit, slide) {
				setTimeout(function() {
					$(slide).find('.focuspoint').data('focusPoint').adjustFocus();
				}, 50);
			});
			
			return true;
		}
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;


/** WEBPACK FOOTER **
 ** ./src/components/focuspoint.js
 **/